module.exports = __webpack_public_path__ + "static/screen04-1023aafcb727a20452d6a907cfceb1b3.jpg";